import { View, StyleSheet, Image, TouchableOpacity, Platform, ActivityIndicator, Dimensions } from 'react-native';
import React from 'react';
let SvgUri;
if (Platform.OS !== 'web') {
    SvgUri = require('react-native-svg').SvgUri;
}
import { ColorTokens, FontFamilyTokens, FontSizeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { COIN_IMG, FRAME_ICON, SIGN_IMG } from './constant';
import Typography from '../../typography/Typography';
import * as Animatable from 'react-native-animatable';
import { getParameters, isFromTDLPlatform } from "../utils";
const HeroSection = ({ fetchMF, loading, triggerAction, onLoadComplete }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const platformCode = params?.platform || '';
    const isfromTDL = isFromTDLPlatform();
    const result = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
            React.createElement(View, { style: styles.container },
                React.createElement(View, { style: styles.heading },
                    React.createElement(View, { style: styles.coinImageContainer },
                        React.createElement(Image, { source: { uri: COIN_IMG }, style: styles.coinImage })),
                    React.createElement(View, { style: styles.textHeading },
                        React.createElement(View, { style: styles.text },
                            React.createElement(Typography, { label: "Get money instantly", fontSize: FontSizeTokens.XL, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 28 })),
                        React.createElement(Typography, { label: "Without selling your mutual funds", fontSize: FontSizeTokens.XS, fontWeight: '500', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, lineHeight: 18 }))),
                React.createElement(View, { style: params?.plj ? styles.subHeadingWithPadding : styles.subHeading },
                    React.createElement(View, { style: styles.buttonElevation, nativeID: 'bt_landingScreen_checkEligible' },
                        React.createElement(TouchableOpacity, { activeOpacity: 1, style: [styles.frameButtonContainer,
                                {
                                    backgroundColor: colorMapping[ColorTokens.Primary_100],
                                    borderRadius: isfromTDL ? 8 : 1000
                                }], onPress: () => {
                                if (fetchMF) {
                                    triggerAction(fetchMF);
                                }
                            } },
                            React.createElement(View, { style: styles.eligibleText },
                                React.createElement(Typography, { label: params?.plj ? "Continue with application" : "Check eligible limit in 15s", fontSize: FontSizeTokens.MD, fontWeight: '700', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.White, lineHeight: 24 })),
                            !loading && !params?.plj && React.createElement(View, { style: styles.iconContainer }, Platform.OS !== 'web' ?
                                React.createElement(SvgUri, { uri: FRAME_ICON }) :
                                React.createElement(React.Fragment, null,
                                    React.createElement(Image, { source: { uri: FRAME_ICON }, style: { width: 24, height: 24 } }))),
                            loading && (React.createElement(ActivityIndicator, { style: { marginLeft: 4 }, animating: true, color: theme.colors[ColorTokens.White] })))),
                    !params?.plj &&
                        React.createElement(View, { style: styles.signContainer },
                            React.createElement(View, { style: styles.signImageContainer },
                                React.createElement(Image, { source: { uri: SIGN_IMG }, style: styles.signImg })),
                            React.createElement(View, { style: styles.creditText },
                                React.createElement(Typography, { label: "No impact on credit score", fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, lineHeight: 18 })))))));
    };
    return result();
};
export default HeroSection;
const styles = StyleSheet.create({
    container: {
        marginHorizontal: 16,
        marginTop: 24,
    },
    heading: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'white',
        borderWidth: 1,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomWidth: 0,
        borderColor: '#E4E7EC',
        elevation: 20,
        shadowColor: '#98A2B3',
        zIndex: 1,
        shadowOffset: {
            width: 0,
            height: 6,
        },
        shadowOpacity: 0.20,
        shadowRadius: 4.65,
    },
    coinImage: {
        height: 87,
        width: 70,
    },
    coinImageContainer: {
        paddingLeft: 12,
        marginRight: 4,
        paddingBottom: 21,
        marginTop: -10,
    },
    textHeading: {
        paddingVertical: 24,
        marginHorizontal: 4,
        flexShrink: 1
    },
    subHeading: {
        display: 'flex',
        backgroundColor: '#FFFFFF',
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        borderWidth: 1,
        borderTopWidth: 0,
        borderColor: '#E4E7EC',
        flex: 1,
    },
    subHeadingWithPadding: {
        display: 'flex',
        backgroundColor: '#FFFFFF',
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        borderWidth: 1,
        borderTopWidth: 0,
        borderColor: '#E4E7EC',
        flex: 1,
        paddingBottom: 24
    },
    buttonElevation: {
        elevation: 24,
        paddingTop: 16,
        paddingHorizontal: 12
    },
    frameButtonContainer: {
        elevation: 24,
        shadowColor: '#1434CB',
        ...Platform.OS === "ios" && {
            shadowOffset: { width: 0, height: 16 },
            shadowOpacity: 0.25,
            shadowRadius: 12,
        },
        flexDirection: 'row',
        marginHorizontal: Dimensions.get('screen').width > 450 ? 16 : 0,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        ...Platform.OS === 'web' && {
            boxShadow: '0 16px 24px 0 rgba(20, 52, 203, 0.25)'
        }
    },
    signImg: {
        height: 12,
        width: 13,
    },
    signContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    signImageContainer: {
        paddingBottom: 23,
        marginTop: 11,
    },
    creditText: {
        paddingBottom: 20,
        marginTop: 8,
        marginLeft: 4,
    },
    text: {
        marginBottom: 4,
    },
    iconContainer: {
        paddingVertical: 12,
        justifyContent: 'center',
    },
    eligibleText: {
        paddingVertical: 12,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 8,
    }
});
